import { combineReducers } from 'redux';
import CarouselItem from './carousel-items/carousel-items-duck.js';
import UserSession from './user-session/user-session-duck.js';
import Category from './categories/categories-duck.js';
import Product from './products/products-duck.js';
import Settings from './settings/settings-duck.js';
import Globals from './globals/globals-duck.js';
import TradeInSimulations from './trade-in-simulations/duck.js';

export default combineReducers({
  UserSession,
  CarouselItem,
  Category,
  Product,
  Settings,
  Globals,
  TradeInSimulations,
});
